

module Elma.Bindings {
    export interface IMenu {
        activateFade?: boolean,
        fadeElm: string
    }


    // overwrites Tapas.Bindings.Menu 
    export class Menu {



        public init(element: any, valueAccessor: () => IMenu, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {

            // 90% of this code comes from Tapas' MenuBinding - only added fade functionality, missing overwrite name in TS :) 

            if (!bindingContext) {
                return;
            }

            var $item = $(element);
            var settings = ko.unwrap(valueAccessor());
            var settingsExists: boolean = typeof settings != "undefined";
            var activateFade: boolean = settingsExists ? settings.activateFade : false; // this setting decides whether backdrop should be on or off
            var fadeElm: string = settingsExists ? settings.fadeElm : ""; // this setting picks which element should be shown as backdrop

            var enableFade: Function = (type: string, activateFade: boolean, fadeElm: string): void => {
                var logger = Ftw.Base.Config.Logger;

                if (activateFade) {
                    var $fadeElm = $(fadeElm);
                    if ($fadeElm.length) {
                        $fadeElm[type](); // hide or show element
                    }
                    else {
                        logger.warning("missing or incorrect fadeElm property on menu data binding, should be a string that contains the class or id of your fade element");
                    }
                }
            }

            $item.click(function (e: Event) {          
                var $clickedElm = $(this);
                var target = $(e.target);

                if (target.hasClass('visible')) {
                    $clickedElm.removeClass('visible');
                    enableFade("hide", activateFade, fadeElm); // hide backdrop when item is hidden
                    if ($clickedElm.hasClass("menu")) {
                        $clickedElm.children().fadeOut(200)
                    }
                }
                else if (target.hasClass('mobileReset')) {
                    $('.visible').removeClass('visible').children().fadeOut(200);
                    bindingContext.$data.menuOpen(true);
                } else if (target.hasClass('item')) {
                    enableFade("show", activateFade, fadeElm); // add backdrop when item is shown
                    $(".setSubmenu").hide(); // hide menu
                    $('.item.visible').removeClass('visible');
                    $clickedElm.addClass('visible');
                    $clickedElm.find(".dropDown").show();
                    bindingContext.$data.menuOpen(true);
                }
                else if (target.hasClass('hasDrop')) {
                    $('.visible').removeClass('visible').children().hide();
                    $clickedElm.addClass('visible');

                    if (!bindingContext.$data.menuOpen()) {
                        $clickedElm.children().fadeIn(200);
                    }
                    else {
                        $clickedElm.children().show();
                    }
              
                    bindingContext.$data.menuOpen(true);
                }

                if (target.hasClass('ecom')) {
                    if (!$(".js-collapse-btn").is(":visible")) {
                        if (!target.hasClass("visible")) {
                            enableFade("hide", activateFade, fadeElm); // hide backdrop when item is hidden
                        }
                        else {
                            enableFade("show", activateFade, fadeElm); // show backdrop when item is hidden
                        }
                    }
                    $clickedElm.children().addClass('active').not(':first').remove();
                }
                else if (target.hasClass("drop")) {
                    if (!$(".js-collapse-btn").is(":visible")) {
                        if (!target.hasClass("visible")) {
                            enableFade("hide", activateFade, fadeElm); // hide backdrop when item is hidden
                        }
                        else {
                            enableFade("show", activateFade, fadeElm); // show backdrop when item is hidden
                        }
                    }
                }

                e.stopPropagation();
            });
        }
    }
    ko.bindingHandlers['menu'] = new Menu();
} 
